module.exports = __webpack_public_path__ + "static/img/ceshi2.f0faa8c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/ceshi2.jpeg
// module id = Qn96
// module chunks = 1